// extracted by mini-css-extract-plugin
module.exports = {"label":"vacancyPriorityLabel_label__3hHiY","urgentLabel":"vacancyPriorityLabel_urgentLabel__pkXsL"};